module.exports = __webpack_public_path__ + "static/img/deadImg.2cd6664a.png";